<template>
	<div class="actions-screen flex flex-center column text-black">
		<div class="col-width text-center">
			<p>
				Nous vous proposons d’interpeller Elisabeth Borne, ministre de la Transition écologique et solidaire. Cet été encore, elle se disait pour la fin de l’huile de palme dans les carburants.
			</p>

			<p>
				Pourtant, à quelques jours de la suppression de l’avantage fiscal sur l’huile de palme, le gouvernement s’acharne à défendre coûte que coûte Total. Il le fait au mépris de l’enjeu climatique, et du fonctionnement démocratique&nbsp;: les parlementaires ont voté pour que l’huile de palme soit moins rentable pour Total, et cette décision doit être respectée.
			</p>
			<p>
				Elisabeth Borne doit empêcher Total de continuer à importer des centaines de milliers de tonnes d’huile de palme en France avec l’argent public&nbsp;!
			</p>


			<blockquote>
				<div>
					<p>
						Le sens de l'Histoire c'est bien de réduire les importations d'huile de palme. En France il n'y a plus d'avantage fiscal pour l’huile de palme en tant que biocarburant.
					</p>

					<footer>
						<cite>
							Elisabeth Borne, 27 août 2019, France Inter
						</cite>
					</footer>
				</div>
			</blockquote>

<!--
			<p class="text-h5">
				Prenons Elisabeth Borne au mot, et rappelons-lui ses engagements&nbsp;!
			</p>
-->

			<p class="text-h5">
				Cette action a pris fin, mais vous pouvez tout de même agir contre la déforestation en <a href="/petition-deforestation/">signant notre pétition</a>.
			</p>

			<p v-if="counter > 1" class="text-h5 text-counter">

					Déjà {{ counter }} personnes ont interpellé le gouvernement

			</p>

		</div>

		<div class="q-my-lg actions-width row wrap justify-center items-stretch">
			<action-btn class="action-button"
				v-model="tab"
				v-for="a in actions"
				:key="a.name"
				:name="a.name"
				:label="a.label"/>

		</div>

		<div class="col-width" ref="actions">

			<q-tab-panels
				v-model="tab"
				>

				<q-tab-panel
					v-for="a in actions"
					:key="a.name"
					:name="a.name"
					:id="a.name"
					>

					<component :is="'action-' + a.name" @count="$count"/>

					<p class="q-pt-lg">
						<b>Une fois que vous avez agi, cliquez sur le bouton "Je confirme avoir agi"</b>.
					</p>

					<p>
						<q-btn class="btn-main q-mt-lg" label="Je confirme avoir agi" @click="submitAction()"/>
					</p>

					<share-items class="share-page"/>

				</q-tab-panel>


			</q-tab-panels>




		</div>
	</div>
</template>

<script>
import ActionBtn from './ActionBtn.vue'
import ShareItems from './ShareItems.vue'

const components = {
	ActionBtn,
	ShareItems,
}


/*
// 20210511 : On enlève les boutons pour indiquer la fermeture de la page
// et renvoyer vers la pétition Deforestation
let actions = [
	{name: "mail", label: "Interpellez la ministre Elisabeth Borne"},
	{name: "rs", label: "Agissez sur les réseaux sociaux"},
	{name: "telephone", label: "Téléphonez au Ministère de la Transition écologique et solidaire"},
	//{name: "carte", label: "Envoyez une carte postale à E.&nbsp;Macron"},
]
*/
let actions = []

if (parseInt(process.env.VUE_APP_V, 10) === 2) {
	actions.push({name: "soutien", label: "Soutenez les activistes"})
}

actions.forEach( (a) => {
	components["action-" + a.name] = require('./actions/' + a.name + '.vue').default
})


export default {
	name: "ActionsScreen",
	components: components,
	props: {
		counter: Number,
		default: String,
	},
	methods: {
		submitAction() {
			this.$count()
			this.$trackEvent("click", "validation action")
			this.$trackEvent("click", "validation action " + this.tab)

			this.$emit('action', this.tab)
		},
	},
	data() {

		return {
			tab: "",
			actions: actions,
			sendEvent: true
		}
	},

	watch: {
		default(n) {
			if (n.length) {
				this.sendEvent = false
				this.tab = n
				this.$nextTick( () => this.sendEvent = true)
			}
		},
		tab(n) {
			if (this.sendEvent) {
				this.$trackEvent("click", "choix action " + n)
				this.$emit('select', this.$refs.actions)
			}
			return n
		}
	}

}
</script>
